export default {
  env: 'production',
  operation_email: 'office@suitup.io,reut@suitup.io',
}